import React from 'react';

import CDNImage from './CDNImage.js';

const alertIcon = 'flood-alert-icon-960-h140.webp';
const warningIcon = 'flood-warning-icon-960-h140.webp';
const severeIcon = 'flood-severe-warning-icon-960-h140.webp';
const clearIcon = 'flood-clear-icon-960-h140.webp';

function FloodAlertIcon({ severityLevel, style }) {
    let computedStyling = {width: "80%", maxWidth: "157px"};
    if(style) {
        computedStyling = style;
    }

    const icons = {
        1: { img: severeIcon, alt: "Severe flood warning icon" },
        2: { img: warningIcon, alt: "Flood warning icon" },
        3: { img: alertIcon, alt: "Flood alert icon" },
        4: { img: clearIcon, alt: "No flood warning icon" }
    };

    const iconData = icons[severityLevel] || icons[4];

    return <CDNImage assetName={iconData.img}  alt={iconData.alt} style={computedStyling} loading="lazy" />
}

export default FloodAlertIcon;
